import Vue from 'vue';
import App from './APP';
import router from '../router';
import store from '../store';
// import Global from './utils/global.js';
import '@/icons'; // 引入svg icon

// 路由权限，路由全局前置守卫，后置守卫
import '@/utils/permission';
// 自定义指定
// import '@/directive/index.js';

// 引入vant
import Vant from 'vant';
import 'vant/lib/index.css';

import 'amfe-flexible';

// 引入全局CSS
import '../styles/index.scss';

Vue.use(Vant);
// import '../utils/vconsole';
// 自定义设置组件标签
// import customComponents from '@/utils/custom-component.js';
// Vue.use(customComponents);

// 定义全局变量-挂载 Vue.prototype
// Vue.prototype.$global = Global;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
